<template>
	<div class="bclass">
		<!-- <div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>弹出活动</div> -->
		<div class="title">
			<div class="left">
				<el-select v-model="filter.state" style="width: 150px;margin-right: 20px;margin-left: 20px;"
					size="small">
					<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" v-model="filter.name" clearable placeholder="请输入弹窗活动名称"
					style="width: 200px;margin-right: 20px;" size="small"></el-input>
				<el-button type="primary" @click="getlist()" size="small">筛选</el-button>
			</div>
			<div class="right">
				<router-link to="/newAt">
					<el-button type="primary" size="small">新建弹出活动</el-button>
				</router-link>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="atDataList" :header-cell-style="{background:'#dbdbdc','text-align':'center'}"
				style="width: 99%;">
				<el-table-column prop="name" align="center" label="弹窗活动名称"></el-table-column>
				<el-table-column prop="userLabelId" align="center" label="用户标签"></el-table-column>
				<el-table-column prop="couponId" align="center" label="优惠券"></el-table-column>
				<el-table-column prop="imgurl" align="center" label="样式">
					<template slot-scope="scope">
						<el-image :src="scope.row.imgurl"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="startTime" align="center" label="开始时间"></el-table-column>
				<el-table-column prop="endTime" align="center" label="结束时间"></el-table-column>
				<el-table-column prop="getNum,totalNum" align="center" label="已领取/优惠券总量">
					<template slot-scope="scope">
						<span>
							{{scope.row.getNum}}/{{scope.row.totalNum}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="state" align="center" label="状态">
					<template slot-scope="scope">
						<span>
							{{scope.row.state==0?'未开始':''}}
							{{scope.row.state==1?'进行中':''}}
							{{scope.row.state==2?'已结束':''}}
							{{scope.row.state==3?'已失效':''}}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="150">
					<template slot-scope="scope">
						<div>
							<el-button @click="deit(scope.row.id)" type="text" size="medium"
								style="margin-right: 20px;">编辑</el-button>
							<el-popconfirm title="确定失效吗？" @onConfirm="invalid(scope.row.id)">
								<el-button :disabled="scope.row.state==3" type="text" size="medium"
									slot="reference"><span style="color: red;">失效</span></el-button>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="turn">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="filter.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="filter.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				filter: {
					pageNum: 1, //页码
					pageSize: 10, // 条数
					state: undefined, // 状态 0未开始-1进行中-2已结束-3已失效
					name: undefined, //活动名称
					total: 1
				},
				activeStateList: [{
					value: undefined,
					label: "全部状态"
				}, {
					value: 0,
					label: "未开始"
				}, {
					value: 1,
					label: "进行中"
				}, {
					value: 2,
					label: "已结束"
				}, {
					value: 3,
					label: "已失效"
				}],
				atDataList: [],
				deleteAd: false,
				change: {
					id: '',
					state: '',
				},
				couponList: [],
				query: {
					page: 2,
					size: 10,
				}
			}
		},
		watch: {
			filter: {
				handler(newValue, oldValue) {
					alert(1)
				},
			}
		},
		mounted() {
			this.getlist();
		},
		methods: {
			deit(id) {
				this.$router.push({
					path: 'newAt',
					query: {
						id: id
					}
				})
			},
			getlist() {
				this.atDataList.length = 0;
				var q = 'pageNum=' + this.filter.pageNum + "&pageSize=" + this.filter.pageSize;
				if (this.filter.state || this.filter.state == 0) q += "&status=" + this.filter.state;
				if (this.filter.name) q += "&name=" + this.filter.name;
				this.$http.get("dvertisement/selectActivity?" + q).then(function(res) {
					this.atDataList = res.body.data;
					this.filter.total = res.body.total;
				})
			},
			handleSizeChange(val) {
				this.filter.pageSize = val
				this.getlist()
			},
			handleCurrentChange(val) {
				this.filter.pageNum = val
				this.getlist()
			},
			invalid(id) {
				this.$http.post("dvertisement/invalidActivity/" + id).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("失效成功")
						this.getlist()
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			position: absolute;
			right: 20px;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}

	.turn {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>